import { UserData } from '@ypp-portal/models/user/userData';
import { Transformation } from '../Transformation';

export class UsernameTransformation extends Transformation {
  constructor(userData: UserData) {
    super('username', userData.static.firstName + ' ' + userData.static.lastName);
  }
}
